// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"nOirLaME","ButtonSkeleton":"IBcrLz6_","IconPlaceholder":"Qze4JUaS","Spinner":"ztj_WMG4","spin":"sw1ogwFp","SubmitPlaceholder":"mYyjt6SM"};